import { Injectable } from '@angular/core';
import { AppSettings } from '../shared/App-Settings';
import { HttpClient, HttpHeaders, HttpRequest, HttpEvent, HttpEventType, HttpResponse } from '@angular/common/http';
import { AuthenticationService } from '../core/authentication.service';
import { Observable, of, throwError } from 'rxjs';
import { tap, catchError, map } from 'rxjs/operators';
import { ResponseDTO } from '../models/response-dto';
import { Packages } from '../models/packages';
import { LocalStorageService, LocalStorageKeyOptions } from '../core/local-storage.service';
import { SessionService, SessionKeyOptions } from '../core/session.service';
import { ArchiveReasonDTO, PackagePostCut } from '../models/packagePostCust';
import { PackageFilterOption } from '../searchFilters/package-filter-option';
import { ImageType, PackageListingSearchEnum, Panel } from '../enums';
import { fil } from 'date-fns/locale';


const apiUrl = AppSettings.API_BASE_URL + "api/";

@Injectable({
  providedIn: 'root'
})
export class PackageServices {

  currentUser: any;
  constructor(private httpClient: HttpClient, private auth: AuthenticationService, private session: SessionService, private localService: LocalStorageService,) {
    this.currentUser = this.localService.getItem(LocalStorageKeyOptions.CurrentUser);
  }

  private handleError<T>(operation = 'operation', result?: T) {
    let errorMsg = '';
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getPackagesGrid(currentPage: number, pageSize: number, order: string, sortby: string, packageCode: string = '', trackingNumber: string = '', customerId: number, status: string = '', overpackID: number, markAvalToshipByFr : boolean = false, countryId :number = 0): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'PackagesGridCollection';

    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;

    if (packageCode) {
      url = url + '&packageCode=' + packageCode;
    }
    if (trackingNumber) {
      url = url + '&trackingNumber=' + trackingNumber;
    }
    if (customerId === 0)
      customerId = -1;
    if (customerId) {
      url = url + '&customerId=' + customerId;
    }
    if (status) {
      url = url + '&status=' + status;
    }
    if (overpackID) {
      url = url + '&overpackId=' + overpackID;
    }
    if(markAvalToshipByFr){
      url = url + '&markAvailableToShipByFranchise='+markAvalToshipByFr;
    }
    if(countryId > 0){
      url = url + '&countryId='+countryId;
    }

    return this.httpClient.get<any>(url, httpOptions);
  }

  getPackages(currentPage: number, pageSize: number, order: string, sortby: string, packageCode: string = '', trackingNumber: string = '', customerId: number, status: string = '', overpackID: number, markAvalToshipByFr : boolean = false, countryId :number = 0,shippingMethod : number = 0): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    if(countryId > 0 && countryId == 151){
      markAvalToshipByFr = null;
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'PackagesCollection';

    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;

    if (packageCode) {
      url = url + '&packageCode=' + packageCode;
    }
    if (trackingNumber) {
      url = url + '&trackingNumber=' + trackingNumber;
    }
    if (customerId === 0)
      customerId = -1;
    if (customerId) {
      url = url + '&customerId=' + customerId;
    }
    if (status) {
      url = url + '&status=' + status;
    }
    if (overpackID) {
      url = url + '&overpackId=' + overpackID;
    }
    if(markAvalToshipByFr){
      url = url + '&markAvailableToShipByFranchise='+markAvalToshipByFr;
    }
    if(countryId > 0){
      url = url + '&countryId='+countryId;
    }
    if(shippingMethod > 0 ){
      url = url + '&ShippingMethod=' + shippingMethod;
    }

    return this.httpClient.get<any>(url, httpOptions);
  }

  getPackagesForBinLocation(currentPage: number, pageSize: number, order: string, sortby: string, packageCode: string = '', trackingNumber: string = '', customerId: number, status: string = '', binLocation: string = '', markAsAvailableToShipByFr : boolean = false): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'getPackagesForBinLocation';

    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;

    if (packageCode) {
      url = url + '&packageCode=' + packageCode;
    }

    if (binLocation) {
      url = url + '&binLocationName=' + binLocation;
    }

    if (customerId) {
      url = url + '&customerId=' + customerId;
    }
    if (status) {
      url = url + '&status=' + status;
    }
    if(markAsAvailableToShipByFr){
      url = url + '&MarkAvailableToShipByFranchise=' + markAsAvailableToShipByFr;
    }

    return this.httpClient.get<any>(url, httpOptions);
  }


  getPackagesForDirectShipment(currentPage: number, pageSize: number, order: string, sortby: string, invoiceId: number): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}getPackagesForDirectShipment`;

    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize;

    if (invoiceId) {
      url = url + '&invoiceId=' + invoiceId;
    }
    return this.httpClient.get<any>(url, httpOptions);
  }

  getPackageById(id: number): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    const url = `${apiUrl}packages/${id}`;

    return this.httpClient.get<any>(url, httpOptions);

  }
  getPackageByPackageCode(filter: PackageFilterOption): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    const url = `${apiUrl}packages/GetByPackageCode?packageCode=${filter.searchKey}&countryId=${filter.CountryId}`;

    return this.httpClient.get<any>(url, httpOptions);

  }
  getOnlyPackageByCode(filter: PackageFilterOption): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    const url = `${apiUrl}packages/GetOnlyPackageByCode?packageCode=${filter.searchKey}&countryId=${filter.CountryId}`;

    return this.httpClient.get<any>(url, httpOptions);

  }

  scanTrackingNumber(trackingNumber: string = ''): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'Miscellaneous/ScanVarifyTracking/' + `${trackingNumber}`;

    let errMsg = '';
    return this.httpClient.get<any>(url, httpOptions).pipe(
      tap(res => {
        if (res["statusCode"] != '200') {
          errMsg = res["statusCode"]["Message"];
          throwError(errMsg);
        }
        console.log('scan tracking number')
      }),
      catchError(this.handleError(errMsg, []))
    );
  }

  AddNewPackage(Package): Observable<Packages> {
    let accessToken = this.auth.getAccessToken();

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}` + 'packages';
    return this.httpClient.post<Packages>(url, Package, httpOptions)
      .pipe(map(res => {
        /*
        if (res && res["result"]) {
          // store package details in session storage 
          let Package: Packages = res["result"];
          // temporary fix for packageId
          let packageId: number;
          packageId = Package.packageUrl.substr(Package.packageUrl.indexOf('api')).match(/\d+/g).map(Number)[0];
          //Package.packageId = packageId;
  
          this.session.setItem(SessionKeyOptions.PackageId, packageId);
  
        }
        */
        return res;
      }));
  }

  UpdatePackage(id, Package): Observable<Packages> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}packages/${id}`;
    return this.httpClient.put<Packages>(url, Package, httpOptions);
  }

  SavePostCutDetail(id, packagePostCut): Observable<PackagePostCut> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'packages/' + `${id}` + '/SavePackagePostCutDetail';
    return this.httpClient.put<PackagePostCut>(url, packagePostCut, httpOptions);
  }
  SaveArchiveReason(id, archiveReason): Observable<ArchiveReasonDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'packages/' + `${id}` + '/archivepackage';
    return this.httpClient.put<ArchiveReasonDTO>(url, archiveReason, httpOptions);
  }
  uploadImages(packageId: number, filesToUpload: any[]) {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let formData = new FormData();

    for (var i = 0; i < filesToUpload.length; i++) {
      formData.append("files", filesToUpload[i], filesToUpload[i]["name"]);
    }

    let url = `${apiUrl}Images?packageId=${packageId}&imageType=1`;

    const config = new HttpRequest('POST', url, formData, {
      reportProgress: true,
      headers: new HttpHeaders({
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    })

    return this.httpClient.request(config);
    //return this.httpClient.post<any>(url, formData, httpOptions);
  }

  GetImagesByPackageId(packageId: number, imageType: ImageType): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}ImageCollection?packageId=${packageId}&imageType=${imageType}`;

    return this.httpClient.get<any>(url, httpOptions);
  }

  DeletePackageImageById(id: number): Observable<number> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}` + "Images/" + `${id}`;
    return this.httpClient.delete<number>(url, httpOptions);
  }

  DeletePackageById(id: number): Observable<number> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}packages/${id}`;
    return this.httpClient.delete<number>(url, httpOptions);
  }

  DetachPackageById(id: number): Observable<number> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}packages/${id}/detachPackage`;
    return this.httpClient.patch<number>(url, httpOptions);
  }

  AddPackageToOverPack(id: number, overpackId: number): Observable<number> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    /*const obj = {
      overpackId: overpackId
    }*/

    let url = `${apiUrl}packages/${id}/addToOverpack?overpackId=${overpackId}`;

    return this.httpClient.put<number>(url, overpackId, httpOptions);
  }

  AddPackageToBinLocation(id: number, binlocationId: number): Observable<number> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    const obj = {
      binLocationId: binlocationId
    }
    let url = `${apiUrl}packages/${id}/addToBinLocation?binLocationId=${binlocationId}`;

    return this.httpClient.put<number>(url, {}, httpOptions);
  }

  getPackageList(customerId: number, shipmentId: number, overpackId: number = null): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };


    let url = `${apiUrl}packageList?customerId=${customerId}&shipmentId=${shipmentId}`;

    if (overpackId) {
      url = url + '&overpackId=' + overpackId;
    }

    return this.httpClient.get<any>(url, httpOptions);
  }

  updatePackageFromOverpack(id): Observable<number> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}packages/${id}/removepackagefromoverpack`;

    return this.httpClient.patch<number>(url, {}, httpOptions);
  }

  createAssociatedPackage(id: number): Observable<ResponseDTO> {

    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}packages/${id}/createAssociatedPackage`;
    return this.httpClient.patch<any>(url, {}, httpOptions);

  }

  getAssociatedPackages(currentPage: number, pageSize: number, order: string, sortby: string, parentPackageId: number): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'PackagesCollection';

    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;

    if (parentPackageId) {
      url = url + '&parentPackageId=' + parentPackageId;
    }

    return this.httpClient.get<any>(url, httpOptions).pipe(
      tap(heroes => console.log('fetched products')),
      catchError(this.handleError('getPackages', []))
    );
  }

  updatePackageStatus(packageId, status): Observable<Packages> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}packages/${packageId}/updatepackagestatus/${status}`;
    return this.httpClient.put<Packages>(url, {}, httpOptions);
  }
  addArchivePackage(packageId, status): Observable<Packages> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}packages/${packageId}/updatepackagestatus/${status}`;
    return this.httpClient.put<Packages>(url, {}, httpOptions);
  }

  restorePackageStatus(packageId): Observable<Packages> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}packages/restorePackageStatus/${packageId}`;
    return this.httpClient.put<Packages>(url, {}, httpOptions);
  }

  getPackageStatus(packageId: number): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}packages/getPackageStatus?packageId=${packageId}`;

    return this.httpClient.get<any>(url, httpOptions);
  }

  addUpdatePackageNotes(id, Package): Observable<Packages> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}packages/${id}/addupdatepackagenotes`;
    return this.httpClient.patch<Packages>(url, Package, httpOptions);
  }

  UpdateCustomerForPackage(id: number, customerId: number): Observable<number> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}packages/${id}/updateCustomerForPackage?customerId=${customerId}`;

    return this.httpClient.put<number>(url, {}, httpOptions);
  }

  getSearchPackages(currentPage: number, pageSize: number, order: string, sortby: string, filter: PackageFilterOption) {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'PackagesCollection';

    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;

    if (filter.searchKey) {
      url = url + '&searchKey=' + filter.searchKey;
    }

    if (filter.franchiseeId)
      url = url + '&franchiseeId=' + filter.franchiseeId;

    if (filter.isFromGlobalSearch)
      url = url + '&isFromGlobalSearch=' + filter.isFromGlobalSearch;

    if(filter.markAsAvailableToShipByFr){
      url = url + '&MarkAvailableToShipByFranchise=' + filter.markAsAvailableToShipByFr;
    }
    if(filter.status){
      url = url + '&Status=' + filter.status;
    }
    if(filter.CountryId){
      url = url + '&CountryId=' + filter.CountryId;
    }
    if(filter.PackageCode){
      url = url + '&PackageCode=' + filter.PackageCode;
    }

    return this.httpClient.get<any>(url, httpOptions).pipe(
      tap(heroes => console.log('fetched products')),
      catchError(this.handleError('getPackages', []))
    );
  }

  getInProcessPackages(currentPage: number, pageSize: number, order: string, sortby: string, packageCode: string = '', trackingNumber: string = '', customerId: number, status: string = '', overpackID: number): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}PackagesInProcess`;

    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;

    return this.httpClient.get<any>(url, httpOptions);
  }

  getRedirectionURL(packageId: number, status: number, hasPickTicket: boolean, binLocation: string) {    
    
    if (this.currentUser.panel == Panel.Franchise) {
      return `/packages/details/${packageId}`;
    }
    else {
      if (hasPickTicket && status == PackageListingSearchEnum.Discarded && (binLocation == "" || binLocation == null || binLocation == undefined)) {
        return `/binlocations/discardPackage/${packageId}`;
      }
      if (hasPickTicket && (binLocation == "" || binLocation == null || binLocation == undefined)) {
        return `/packages/edit/${packageId}`;
      }
      else {
        switch (status) {
          case PackageListingSearchEnum.ReturnRequestPending:             
          case PackageListingSearchEnum.PendingReturnPayment: 
          case PackageListingSearchEnum.PendingReturnShipment: 
          case PackageListingSearchEnum.ShipmentReturned:
            return `/binlocations/returnPackage/${packageId}`;
          case PackageListingSearchEnum.DiscardRequestPending: 
          case PackageListingSearchEnum.Discarded:
            return (!hasPickTicket) ? `/packages/details/${packageId}` : `/binlocations/discardPackage/${packageId}`;
          case PackageListingSearchEnum.OnHold:
          case PackageListingSearchEnum.AvailableToShip:
          case PackageListingSearchEnum.Unknown:
          case PackageListingSearchEnum.Restricted:
          case PackageListingSearchEnum.HoldToShip:
          case PackageListingSearchEnum.Attached:
            return `/packages/edit/${packageId}`;
          default:
            return `/packages/details/${packageId}`;
        }
      }
    }
  }
  reActivePackageStatus(packageId): Observable<Packages> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}packages/${packageId}/restorePackageStatus`;
    return this.httpClient.patch<Packages>(url, {}, httpOptions);
  }
  azPackageFileUpload(file){
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({        
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let formData = new FormData();
    formData.append("file", file, file["name"]);

    let url = `${apiUrl}packages/UpdateMarkAvailabletoShipByFr`;
    return this.httpClient.post<any>(url, formData, httpOptions);
  }

  getPackagesForBinLocationCount(status: string = '', markAsAvailableToShipByFr : boolean = false, countryId:string,shippingMethod : number = 1): Observable<ResponseDTO> {    
    
    let accessToken = this.auth.getAccessToken();
    if(countryId != "" && countryId == '151'){
      markAsAvailableToShipByFr = null;
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'packages/PackageCountForBinLocation?';        
    if (status) {
      url = url + 'status=' + status;
    }
    if(markAsAvailableToShipByFr){
      url = url + '&MarkAvailableToShipByFranchise=' + markAsAvailableToShipByFr;
    }
    if(countryId != null && countryId != ""){
      url = url + '&CountryId=' + countryId;
    }
    if(shippingMethod > 0){
      url = url + '&ShippingMethod=' + shippingMethod;
    }

    return this.httpClient.get<any>(url, httpOptions);
  }

  AddPackageArchiveNote(id, notes) {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}packages/AddPackageNote?packageId=${id}&note=${notes}`;
    return this.httpClient.get(url, httpOptions);
  }

  OverrideDiscardPackage(packageId){
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({        
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    
    let url = `${apiUrl}packages/${packageId}/PackageOverrideDiscard`;
    return this.httpClient.put<any>(url,httpOptions);
  }

}
